module.exports = __webpack_public_path__ + "media/images/icon-svg/winterkost-2b42b3f0d5ebf2794f53d0d8f691a5a4.svg";